import { useState, useEffect } from "react";
import { Button, Grid2, Alert, Dialog, Snackbar} from "@mui/material";
import { Box, Fab } from "@mui/material";
import ReplyRoundedIcon from "@mui/icons-material/ReplyRounded";
import axios from "axios";

function AdminVideos() {
  const [videos, setVideos] = useState([null, null, null, null, null]);
  const [loadingIndex, setLoadingIndex] = useState(null);
  const [errorText, setErrorText] = useState('');
  const [successText, setSuccessText] = useState('');
  const [error, setError] = useState(false);
  const [open, setOpen] = useState(false);

  const fetchVideos = async () => {
  try {
    const response = await axios.get("https://api.sigmasystems.com.br/api/odontoluzzi/videos");
    const data = response.data;

    const loadedVideos = [null, null, null, null, null];
    data.forEach((item) => {
      loadedVideos[item.slot] = item.url 
        ? `https://api.sigmasystems.com.br/api/odontoluzzi${item.url}` 
        : null;
    });

    setVideos(loadedVideos);
  } catch (err) {
    console.error("Erro ao buscar vídeos:", err);
  }
};

  useEffect(() => {
    fetchVideos();
  }, []);

  const handleSelectVideo = (index) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "video/*";
    input.onchange = async (e) => {
      const file = e.target.files[0];
      if (file) {
        await uploadVideo(file, index);
      }
    };
    input.click();
  };
  const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
          return;
      }
      setError(false);
      setOpen(false);
  };

  const uploadVideo = async (file, index) => {
    setLoadingIndex(index);
    try {
      const formData = new FormData();
      formData.append("video", file);

      await axios.post(
        `https://api.sigmasystems.com.br/api/odontoluzzi/videos/upload/${index}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      await fetchVideos();
      setOpen(true);
      setSuccessText('Vídeo alterado!')
    } catch (err) {
      setError(true);
      setErrorText('Erro ao alterar Vídeo.')
    } finally {
      setLoadingIndex(null);
    }
  };

  return (
    <div className="container">
      <div className="body" style={{ justifyItems: "center", width: "100%" }}>
        <div className="adminMenuContainer">
          <div className="adminTitle">Vídeos Educacionais</div>

          <div
            className="adminMenuContent"
            style={{
              maxWidth: "1280px",
              height: "fit-content",
              maxHeight: "700px",
              borderRadius: "0px 0px 10px 10px",
              padding: "20px",
            }}
          >
            <div className="adminSubTitle">Lista de Vídeos</div>

            <Grid2 container spacing={2} sx={{ marginTop: 2 }}>
              {videos.map((video, index) => (
                <Grid2
                  item
                  key={index}
                  xs={12}
                  sm={6}
                  md={4}
                  lg={2.4}
                  onClick={() => handleSelectVideo(index)}
                  sx={{
                    cursor: "pointer",
                    border: "2px dashed #B08E44",
                    borderRadius: "10px",
                    padding: "10px",
                    width:140,
                    alignContent:'center',
                    textAlign: "center",
                    "&:hover": { backgroundColor: "#f9f9f9" },
                  }}
                >
                  {loadingIndex === index ? (
                    <div>Enviando...</div>
                  ) : video ? (
                    <video
                      src={video}
                      muted
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "cover",
                        borderRadius: "10px",
                        pointerEvents: "none", 
                      }}
                    />
                  ) : (
                    <div style={{ color: "#B08E44" }}>
                      Clique para adicionar vídeo {index + 1}
                    </div>
                  )}
                </Grid2>
              ))}
            </Grid2>
          </div>
        </div>
      </div>
      <Box
          sx={{
          "& > :not(style)": { m: 1 },
          position: "absolute",
          bottom: 16,
          right: 16,
          }}
      >
          <Fab
          onClick={() => window.history.back()}
          variant="extended"
          sx={{
              backgroundColor: "#B08E44",
              color: "#fff",
              "&:hover": { backgroundColor: "#041819" },
          }}
          >
          <ReplyRoundedIcon sx={{ mr: 1 }} /> Voltar
          </Fab>
      </Box>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{vertical:'bottom',horizontal:'right'}}>
          <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
          >
          {successText}
          </Alert>
      </Snackbar>
      <Snackbar open={error} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{vertical:'bottom',horizontal:'right'}}>
          <Alert
          onClose={handleClose}
          severity="error"
          variant="filled"
          sx={{ width: '100%' }}
          >
          {errorText}
          </Alert>
      </Snackbar>
    </div>
  );
}

export default AdminVideos;
